class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

const facetForm = this.querySelector("form");
if (facetForm) {
	facetForm.addEventListener("change", this.debouncedOnSubmit);
}

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		this.addEventListener("click", (event) => {
			const button = event.target.closest(".per-row__button");
			if (button) {
				const perRow = button.dataset.perRow;
				this.querySelectorAll(".per-row__button").forEach((btn) => {
					btn.classList.toggle("active", btn.dataset.perRow === perRow);
				});
				const gridContainer = document.querySelector("[data-productis-in-row]");
				if (gridContainer) {
					gridContainer.setAttribute("data-productis-in-row", perRow);
				}
				localStorage.setItem("productsPerRow", perRow);
			}
		});

this.addEventListener("click", (event) => {
	const dropdown = event.target.closest(".facets-inline-dropdown");
	if (dropdown) {
		event.stopPropagation();
	}
});
document.addEventListener("click", (e) => {
	const openItems = document.querySelectorAll(".facets-inline-item[open]");
	const clickedItem = e.target.closest(".facets-inline-item");

	if (!clickedItem) {
		openItems.forEach((item) => {
			item.removeAttribute("open");
		});
		return;
	}

	openItems.forEach((item) => {
		if (item !== clickedItem) {
			item.removeAttribute("open");
		}
	});
});

this.addEventListener(
	"toggle",
	(event) => {
		const currentItem = event.target.closest(".facets-inline-item");
		if (!currentItem || !currentItem.open) return;

		document.querySelectorAll(".facets-inline-item[open]").forEach((item) => {
			if (item !== currentItem) {
				item.removeAttribute("open");
			}
		});
	},
	true
);
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);
	}

	static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById("ProductCountDesktop");

		document
			.getElementById("ProductGridContainer")
			.querySelector(".collection")
			.classList.add("loading");

		if (countContainer) countContainer.classList.add("loading");
		if (countContainerDesktop) countContainerDesktop.classList.add("loading");

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static renderSectionFromFetch(url, event) {
		fetch(url)
			.then((response) => response.text())
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderFilters(html, event);
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderProductCount(html);

				var swiper = new Swiper(".swiper-container", {
					slidesPerView: 1,
					spaceBetween: 0,
					navigation: {
						nextEl: ".product-button-group .swiper-button-next-1",
						prevEl: ".product-button-group .swiper-button-prev-1",
					},
				});
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
		FacetFiltersForm.renderFilters(html, event);
		FacetFiltersForm.renderProductGridContainer(html);
		FacetFiltersForm.renderProductCount(html);
	}

	static renderProductGridContainer(html) {
		document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
			.parseFromString(html, "text/html")
			.getElementById("ProductGridContainer").innerHTML;

		if (
			document.querySelector(".js-load-more") ||
			document.querySelector(".js-infinite-scroll")
		) {
			loadMore();
		}

		colorSwatches();
	}

	static renderProductCount(html) {
		const parsed = new DOMParser().parseFromString(html, "text/html");
		const countEl = parsed.getElementById("ProductCount");
		if (!countEl) return;

		const raw = countEl.innerText || countEl.textContent;
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");

		if (!container || !containerDesktop) return;

		let match = raw.match(/\d+/g);
		if (match) {
			const count = match.pop();
			container.innerText = `${count} products`;
			containerDesktop.innerText = `${count} products`;
		} else {
			container.innerText = raw;
			containerDesktop.innerText = raw;
		}

		container.classList.remove("loading");
		containerDesktop.classList.remove("loading");
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);

		let jsFilter = event?.target?.closest(".js-filter");
		let matchesIndex = (element) =>
			jsFilter && element.dataset?.index === jsFilter.dataset?.index;

		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);

		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			let current = document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			);
			if (current) current.innerHTML = element.innerHTML;
		});

		document.querySelectorAll("price-range").forEach((element) => {
	if (typeof element.controlSlider === "function") {
		element.fillSlider?.();
	}
});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender && jsFilter) {
			FacetFiltersForm.renderCounts(countsToRender, jsFilter);
		}
	}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			if (!activeFacetsElement) return;

			const currentElement = document.querySelector(selector);
			if (currentElement) {
				currentElement.innerHTML = activeFacetsElement.innerHTML;
			}
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			const source = html.querySelector(selector);
			const target = document.querySelector(selector);
			if (!source || !target) return;
			target.innerHTML = source.innerHTML;
		});
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${searchParams && "?".concat(searchParams)}`
		);
	}

	static getSections() {
		return [
			{
				section: document.getElementById("product-grid").dataset.id,
			},
		];
	}

	createSearchParams(form) {
		const formData = new FormData(form);
		return new URLSearchParams(formData).toString();
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

onSubmitHandler(event) {
	const form = event.target.closest("form");
	if (!form) return;

	const noJsElements = document.querySelectorAll(".no-js-list");
	noJsElements.forEach((el) => el.remove());

	const searchParams = this.createSearchParams(form);
	console.log("Submitting filters:", searchParams);

	this.onSubmitForm(searchParams, event);
}

	onActiveFilterClick(event) {
		event.preventDefault();
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();

		this.minNumberInput = this.querySelector('.facets__price-wrapper .field__input:first-child');
		this.maxNumberInput = this.querySelector('.facets__price-wrapper .field__input:last-child');
		this.minRangeInput = this.querySelector('.facets__range .field__range:first-child');
		this.maxRangeInput = this.querySelector('.facets__range .field__range:last-child');

		if (!this.minNumberInput || !this.maxNumberInput || !this.minRangeInput || !this.maxRangeInput) return;

		this.bindEvents();
		this.syncFromInputs();
		this.updateSliderFill();
	}

	bindEvents() {
		this.minRangeInput.addEventListener('input', () => {
			let min = this.toNumber(this.minRangeInput.value, 0);
			let max = this.toNumber(this.maxRangeInput.value, this.getAbsoluteMax());

			if (min > max) {
				min = max;
				this.minRangeInput.value = min;
			}

			this.minNumberInput.value = min;
			this.updateSliderFill();
		});

		this.maxRangeInput.addEventListener('input', () => {
			let min = this.toNumber(this.minRangeInput.value, 0);
			let max = this.toNumber(this.maxRangeInput.value, this.getAbsoluteMax());

			if (max < min) {
				max = min;
				this.maxRangeInput.value = max;
			}

			this.maxNumberInput.value = max;
			this.updateSliderFill();
		});

		this.minRangeInput.addEventListener('change', () => {
			this.dispatchFormChange();
		});

		this.maxRangeInput.addEventListener('change', () => {
			this.dispatchFormChange();
		});

		this.minNumberInput.addEventListener('input', () => {
			this.syncNumberInputsToRanges();
		});

		this.maxNumberInput.addEventListener('input', () => {
			this.syncNumberInputsToRanges();
		});

		this.minNumberInput.addEventListener('change', () => {
			this.finalizeNumberInputs();
			this.dispatchFormChange();
		});

		this.maxNumberInput.addEventListener('change', () => {
			this.finalizeNumberInputs();
			this.dispatchFormChange();
		});
	}

	toNumber(value, fallback) {
		const n = parseInt(value, 10);
		return Number.isNaN(n) ? fallback : n;
	}

	getAbsoluteMin() {
		return this.toNumber(this.minRangeInput.min, 0);
	}

	getAbsoluteMax() {
		return this.toNumber(this.maxRangeInput.max, 0);
	}

	syncFromInputs() {
		let min = this.toNumber(this.minNumberInput.value, this.getAbsoluteMin());
		let max = this.toNumber(this.maxNumberInput.value, this.getAbsoluteMax());

		if (min < this.getAbsoluteMin()) min = this.getAbsoluteMin();
		if (max > this.getAbsoluteMax()) max = this.getAbsoluteMax();
		if (min > max) min = max;

		this.minNumberInput.value = min;
		this.maxNumberInput.value = max;
		this.minRangeInput.value = min;
		this.maxRangeInput.value = max;
	}

	syncNumberInputsToRanges() {
		let minRaw = this.minNumberInput.value.trim();
		let maxRaw = this.maxNumberInput.value.trim();

		let min = minRaw === '' ? this.getAbsoluteMin() : this.toNumber(minRaw, this.getAbsoluteMin());
		let max = maxRaw === '' ? this.getAbsoluteMax() : this.toNumber(maxRaw, this.getAbsoluteMax());

		if (min < this.getAbsoluteMin()) min = this.getAbsoluteMin();
		if (max > this.getAbsoluteMax()) max = this.getAbsoluteMax();
		if (min > max) {
			if (document.activeElement === this.minNumberInput) {
				max = min;
			} else {
				min = max;
			}
		}

		this.minRangeInput.value = min;
		this.maxRangeInput.value = max;
		this.updateSliderFill();
	}

	finalizeNumberInputs() {
		let min = this.toNumber(this.minNumberInput.value, this.getAbsoluteMin());
		let max = this.toNumber(this.maxNumberInput.value, this.getAbsoluteMax());

		if (min < this.getAbsoluteMin()) min = this.getAbsoluteMin();
		if (max > this.getAbsoluteMax()) max = this.getAbsoluteMax();
		if (min > max) min = max;

		this.minNumberInput.value = min;
		this.maxNumberInput.value = max;
		this.minRangeInput.value = min;
		this.maxRangeInput.value = max;
		this.updateSliderFill();
	}

	updateSliderFill() {
		const min = this.toNumber(this.minRangeInput.value, this.getAbsoluteMin());
		const max = this.toNumber(this.maxRangeInput.value, this.getAbsoluteMax());
		const absoluteMin = this.getAbsoluteMin();
		const absoluteMax = this.getAbsoluteMax();
		const range = absoluteMax - absoluteMin || 1;

		const minPercent = ((min - absoluteMin) / range) * 100;
		const maxPercent = ((max - absoluteMin) / range) * 100;

		this.querySelector('.facets__range')?.style.setProperty('--range-min', `${minPercent}%`);
		this.querySelector('.facets__range')?.style.setProperty('--range-max', `${maxPercent}%`);
	}

	dispatchFormChange() {
		const form = this.closest('form');
		if (!form) return;

		form.dispatchEvent(new Event('change', { bubbles: true }));
	}
}

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		if (!facetLink) return;

		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		if (form) form.onActiveFilterClick(event);
	}
}
customElements.define("facet-remove", FacetRemove);

document.addEventListener("click", function (event) {
  const clickedClear = event.target.closest(
    ".active-facets__button-remove, .main-facets-remove, .title-wrapper-empty .underlined-link.link"
  );

  if (clickedClear) {
    sessionStorage.setItem("skipAutoInStock", "true");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const isCollectionPage = path.includes("/collections/");

  const shouldSkipAutoInStock =
    sessionStorage.getItem("skipAutoInStock") === "true";

  if (shouldSkipAutoInStock) {
    sessionStorage.removeItem("skipAutoInStock");
    return;
  }

  const hasAvailabilityFilter = params.has("filter.v.availability");

  if (isCollectionPage && !hasAvailabilityFilter) {
    params.set("filter.v.availability", "1");
    window.location.replace(`${path}?${params.toString()}`);
  }
});